import { IRange } from "monaco-editor";

import { PositionBis as CliPosition } from "@types";

import { CodeLoc } from "@pages/editor/types";

const spanToHighlightRange = (start: CodeLoc, end: CodeLoc): IRange => ({
  startLineNumber: start.line,
  startColumn: start.col ?? 0,
  endLineNumber: end.line,
  endColumn: end.col ?? Infinity,
});

export const makeHighlight = (
  start: CliPosition,
  end?: CliPosition,
  newEnd?: CodeLoc
) => {
  const endLine = end?.line ?? start.line; // if no end.line, assume one line
  const range = spanToHighlightRange(start, {
    col: newEnd?.col ?? end?.col,
    line: newEnd?.line ?? endLine,
  });
  return {
    range,
    startLine: start.line,
    endLine: newEnd ? newEnd.line : endLine,
  };
};
